<template>
    <div>
        <template v-if="busy">
            <CenteredMessage :spinner="busy">
                <template>Lädt Widget...</template>
            </CenteredMessage>
        </template>
        <template v-else>
            <LineChart v-if="loaded" :chartdata="chartData" />
        </template>
    </div>
</template>

<script>
import WidgetContent from "@/mixins/Widget/WidgetContent";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";
import LineChart from "@/components/LineChart/LineChart";

export default {
    name: "Anwesenheitsstatistik",
    mixins: [WidgetContent],
    components: {
        CenteredMessage,
        LineChart
    },
    props: ["url"],
    data() {
        return {
            loaded: false,
            chartData: {}
        };
    },
    methods: {
        process(items) {
            items = items.werke.reverse();

            var chartData = {
                labels: [],
                datasets: []
            };

            var datasetHosts = {
                data: [],
                label: "teilnehmende Mitglieder",
                borderColor: "rgba(177, 223, 187, 1)",
                backgroundColor: "rgba(177, 223, 187, 0.5)",
                fill: true
            };
            var datasetHostsTotal = {
                data: [],
                label: "Mitglieder gesamt",
                borderColor: "rgba(214, 216, 219, 0.75)",
                backgroundColor: "rgba(214, 216, 219, 1)",
                fill: false
            };
            for (const item of items) {
                chartData.labels.push(item.id);
                datasetHosts.data.push(item.hosts);
                datasetHostsTotal.data.push(item.hosts_total);
            }
            chartData.datasets.push(datasetHosts, datasetHostsTotal);

            this.chartData = chartData;
            this.loaded = !this.loaded;
        }
    }
};
</script>